import { EmptyStateIcons, Table } from '@silverfort/sf-components';
import { useUsersTableColumns } from './useUsersTableColumns';
import { FC, useRef } from 'react';
import { SortDirection } from '@silverfort/sf-components/dist/Table/interface';
import { User } from '../../../types/User';
import useGetRefSize from '../../../../../hooks/useGetRefSize';
import { UsersViewRenderMode } from './UsersViewRenderMode';

type UsersTableProps = {
    loading: boolean;
    onScrollEnd?: () => void;
    onSort?: (field: keyof User, direction: SortDirection) => void;
    outerHeight?: number;
    renderMode?: UsersViewRenderMode;
    users: Array<User>;
};

export const UsersTable: FC<UsersTableProps> = ({ loading, onScrollEnd, onSort, outerHeight, renderMode, users }) => {
    const tableRef = useRef(null);
    const { height } = useGetRefSize(tableRef);

    const columns = useUsersTableColumns(renderMode);

    return (
        <div ref={tableRef} className="w-full h-full">
            <Table
                EmptyStateProps={{
                    className: 'w-full h-full',
                    icon: EmptyStateIcons.NoItems,
                    title: 'There are no Users'
                }}
                bodyHeight={outerHeight || (height && height - 50)}
                columns={columns}
                loading={loading}
                onScrollEnd={onScrollEnd}
                onSortChange={onSort}
                rows={users}
                tableContainerClassName={`w-full h-full flex flex-col`}
            />
        </div>
    );
};
